import {
  deleteCouponApi,
  generateCouponApi,
  generateGenericCouponApi,
  getAllGenericCouponApi,
  getAllCouponApi,
  getSingleCouponApi,
  updateCouponApi,
} from "../../api/ecommerce/CouponsApi";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  generateCouponResponse: {},
  generateGenericCouponResponse: {},
  coupons: [],
  genericCoupons: [],
  coupon: {},
  editCoupon: {
    isEdit: false,
    body: {},
  },
  loading: false,
  successful: false,
  uploading: false,
};

export const generateCoupon = createAsyncThunk(
  "coupon/generateCoupon",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await generateCouponApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getAllCoupon = createAsyncThunk(
  "coupon/getAllCoupon",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllCouponApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const generateGenericCoupon = createAsyncThunk(
  "coupon/generateGenericCoupon",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await generateGenericCouponApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getAllGenericCoupon = createAsyncThunk(
  "coupon/getAllGenericCoupon",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllGenericCouponApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const updateCoupon = createAsyncThunk(
  "coupon/updateCoupon",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateCouponApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const deleteCoupon = createAsyncThunk(
  "coupon/deleteCoupon",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteCouponApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getSingleCoupon = createAsyncThunk(
  "coupon/getSingleCoupon",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getSingleCouponApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {
    setCouponData: (state, action) => {
      state.coupon = {};
    },
    setCouponResponse: (state, action) => {
      state.generateCouponResponse = {};
    },
    setGenericCouponResponse: (state, action) => {
      state.generateGenericCouponResponse = {};
    },
    setEditCoupon: (state, action) => {
      state.editCoupon = {
        isEdit: action.payload.isEdit,
        body: action.payload.body,
      }
    },
  },
  extraReducers: (builder) => {
    // generate coupon
    builder.addCase(generateCoupon.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(generateCoupon.fulfilled, (state, action) => {
      state.generateCouponResponse = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(generateCoupon.rejected, (state) => {
      state.uploading = false;
    });

    // generate generic coupon
    builder.addCase(generateGenericCoupon.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(generateGenericCoupon.fulfilled, (state, action) => {
      state.generateGenericCouponResponse = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(generateGenericCoupon.rejected, (state) => {
      state.uploading = false;
    });

    // update coupon
    builder.addCase(updateCoupon.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateCoupon.fulfilled, (state, action) => {
      state.generateCouponResponse = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateCoupon.rejected, (state) => {
      state.uploading = false;
    });

    // delete coupon
    builder.addCase(deleteCoupon.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(deleteCoupon.fulfilled, (state, action) => {
      state.generateCouponResponse = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(deleteCoupon.rejected, (state) => {
      state.uploading = false;
    });

    // get all coupons
    builder.addCase(getAllCoupon.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllCoupon.fulfilled, (state, action) => {
      state.coupons = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllCoupon.rejected, (state) => {
      state.loading = false;
    });

    // get all generic coupons
    builder.addCase(getAllGenericCoupon.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllGenericCoupon.fulfilled, (state, action) => {
      state.genericCoupons = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllGenericCoupon.rejected, (state) => {
      state.loading = false;
    });

    // get single coupon
    builder.addCase(getSingleCoupon.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleCoupon.fulfilled, (state, action) => {
      state.coupon = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getSingleCoupon.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const {
  setCouponData,
  setCouponResponse,
  setGenericCouponResponse,
  setEditCoupon,
} = couponSlice.actions;
export default couponSlice.reducer;
